import { lazy } from "react";

const Expenses = lazy(() => import("./expenses"));
const Suppliers = lazy(() => import("./Suppliers"));

const ExpensesRoutes = [
  {
    path: "/expenses/expense",
    element: <Expenses />,
  },
  {
    path: "/expenses/Suppliers",
    element: <Suppliers />,
  },
 
];

export default ExpensesRoutes;
